
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../lib/data";

export const Testimonials = () => {
    const prefix = "//";
    return (
        <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-[#060c1c]">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                        {prefix} Word on the street
                    </div>
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
                        Trusted by owners who{" "}
                        <span className="text-gradient-cyan">don't have time to babysit</span> their developer.
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-5">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.div
                            key={t.name}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            data-testid={`testimonial-${i}`}
                            className="relative p-7 rounded-2xl border border-white/5 bg-[#0a1024] hover:border-cyan-400/30 transition-all"
                        >
                            <Quote size={30} className="text-cyan-400/30 mb-4" />
                            <p className="text-slate-200 leading-relaxed text-[17px] mb-6">"{t.quote}"</p>
                            <div className="flex items-center justify-between pt-5 border-t border-white/5">
                                <div>
                                    <div className="font-semibold">{t.name}</div>
                                    <div className="text-xs text-slate-400">{t.role}</div>
                                </div>
                                <div className="flex gap-0.5">
                                    {[...Array(5)].map((_, k) => (
                                        <Star key={k} size={13} className="fill-cyan-400 text-cyan-400" />
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
